// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1FeatureRequestsCreateSchema = z.object({
  description: z.coerce.string().min(1).max(5000).describe("Free-text description of the feedback (required, max 5000 chars)."),
  feedback_type: z.enum(["feature_request", "general_feedback"]).describe("Type of feedback. Bug reports are routed to Intercom, not this endpoint."),
  problem: z.coerce.string().max(5000).describe("Problem the user is trying to solve. Required when feedback_type is feature_request.").nullish(),
  desired_outcome: z.coerce.string().max(5000).describe("Desired outcome / what success looks like. Required when feedback_type is feature_request.").nullish(),
  importance: z.enum(["nice_to_have", "important", "critical"]).describe("How important the feedback is.").nullish(),
  frequency: z.enum(["rarely", "sometimes", "often", "always"]).describe("How often the issue/need comes up.").nullish(),
  is_blocking: z.coerce.string().max(32).describe("Optional free-text indicator that the feedback is blocking work.").nullish(),
  current_page: z.coerce.string().max(500).describe("Pathname of the page where the feedback was submitted.").nullish(),
  context: z.optional(z.object({
    browser: z.coerce.string().max(100).describe("Browser name/version.").nullish(),
    os: z.coerce.string().max(100).describe("Operating system.").nullish(),
    device_type: z.coerce.string().max(100).describe("Device type (e.g. desktop, mobile).").nullish(),
  })),
});
